import { html, nothing } from 'lit';
import { fetchAleksBundleDurationInDays, fetchSharpenCompanionBundleDurationInDays } from '../../../common/utils/aleks-sharpen-bundle-util';
import { getPriceWithCurrency, getProductEndAccessDate } from '../../../common/utils/cart-util';
import { ProductCardData } from '../product-card-display';

/**
 * Generates the product card metadata identifiers text.
 *
 * @param identifiers
 * @param showIdentifiers
 */
export function generateProductCardMetadataIdentifiersText(identifiers, showIdentifiers) {
  if (showIdentifiers && identifiers && Object.keys(identifiers).length > 0) {
    const identifierHTML = html`${Object.entries(identifiers).map(
      ([key, value], index, array) => html`
        <span class="fw-semibold">${key}:</span> ${value}${index !== array.length - 1 ? ' | ' : ''}
      `
    )}`;
    return html`<p class="mb-1 fs-small">${identifierHTML}</p>`;
  } else {
    return nothing;
  }
}

export function aleksSharpenCheckoutCard(product: ProductCardData) {
  return html`
    <div class="col-9">
      <div class="d-flex justify-content-between align-items-start pb-3">
        <div class="fw-bold mb-0 pe-1">
          ${product?.title}
        </div>
        <div class="fs-large fw-bold">${getPriceWithCurrency(product?.currencyCode, product?.totalPrice || 0.0)}</div>
      </div>
      <div class="fs-small">
        <div class="pb-1">
          <span>
            <strong class="pe-1">ALEKS Access Until:</strong>
            ${getProductEndAccessDate(fetchAleksBundleDurationInDays(product.metaOfferContentsMetadata)?.toString() || '')}
          </span>
        </div>
        <div>
          <span>
            <strong class="pe-1">Sharpen Access Until:</strong>
            ${getProductEndAccessDate(fetchSharpenCompanionBundleDurationInDays(product.metaOfferContentsMetadata)?.toString() || '')}
          </span>
        </div>
      </div>
    </div>   
  `;
}
